import {User} from "../model/User";

export const getMembers = () => {
  return [
    new User({number: '111', name: 'すみの'}),
    new User({number: '222', name: 'しょうじ'}),
    new User({number: '333', name: 'しもはら'}),
  ]
}
